import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

export const fixedButtonWrapper = css`
  position: fixed;
  inset-block-end: 0;
  inset-inline: 0;
  block-size: unset;
  box-shadow: ${cssTheme.shadows.topNormal};
`
